'use client';

import { useState } from 'react';

type TUsePagination = {
    totalItems: number;
    pageSize?: number;
    handlePageChange?: (pageIdx: number) => void;
    initialPageIdx?: number;
};

export const usePagination = ({
    totalItems,
    pageSize = 20,
    initialPageIdx = 0,
    handlePageChange = () => {},
}: TUsePagination) => {
    const [currentPageIdx, setCurrentPageIdx] = useState(initialPageIdx);
    const totalPages = Math.ceil(totalItems / pageSize);

    const handlePageOpen = (idx: number) => {
        if (idx >= 0 && idx < totalPages) {
            setCurrentPageIdx(idx);
            handlePageChange(idx);
        }
    };

    return {
        currentPageIdx,
        totalPages,
        handlePageOpen,
    };
};
